export default __webpack_public_path__ + "static/media/desktop_tc1_Hk.e8f32cae.webp";